<!-- Copyright (c) 2017-2022 VMware, Inc. All rights reserved. VMware Confidential -->

<span *ngIf="copied">
   {{'copy.to.clipboard.copied' | vtranslate}}
</span>
<cds-icon shape="copy-to-clipboard"
          status="info">
    {{'copy.to.clipboard' | vtranslate }}
</cds-icon>
